import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="p-1 mx-4 mt-1 text-xs text-center border-t border-lines text-dimmed">
      &copy; 2022 ExRates. All Rights Reserved.
    </footer>
  );
}
